import React, { useState, useEffect } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Container,
  IconButton,
  useTheme,
} from '@mui/material';
import { motion, Variants } from 'framer-motion';
import { Code as CodeIcon } from '@mui/icons-material';
import { neonVariants, textRevealVariants, pageVariants } from '../../animations/variants';

const AnimatedHeader: React.FC = () => {
  const theme = useTheme();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const headerVariants = pageVariants;

  const iconVariants: Variants = {
    initial: { scale: 0, rotate: -180 },
    animate: { 
      scale: 1, 
      rotate: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2,
      }
    },
    hover: {
      scale: 1.1,
      rotate: 360,
      transition: {
        duration: 0.3,
        ease: 'easeOut',
      }
    },
  };

  return (
    <motion.div
      initial="initial"
      animate="animate"
      variants={headerVariants}
    >
      <AppBar
        position="fixed"
        elevation={scrolled ? 4 : 0}
        sx={{
          background: scrolled 
            ? 'rgba(10, 10, 10, 0.95)' 
            : 'transparent',
          backdropFilter: scrolled ? 'blur(20px)' : 'none',
          borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
          transition: 'all 0.3s ease',
        }}
      >
        <Container maxWidth="xl">
          <Toolbar disableGutters>
            <motion.div
              variants={iconVariants}
              whileHover="hover"
              style={{ marginRight: theme.spacing(2) }}
            >
              <IconButton
                size="large"
                edge="start"
                color="inherit"
                aria-label="logo"
                sx={{
                  background: 'linear-gradient(135deg, #00D4FF 0%, #FF00FF 100%)',
                  borderRadius: '12px',
                  padding: '8px',
                }}
              >
                <CodeIcon sx={{ color: '#FFFFFF' }} />
              </IconButton>
            </motion.div>

            <motion.div
              variants={textRevealVariants}
              initial="hidden"
              animate="visible"
              transition={{ delay: 0.3 }}
            >
              <Typography
                variant="h6"
                component="div"
                sx={{
                  fontFamily: '"Orbitron", sans-serif',
                  fontWeight: 700,
                  background: 'linear-gradient(135deg, #00D4FF 0%, #FF00FF 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                  textShadow: '0 0 20px rgba(0, 212, 255, 0.5)',
                }}
              >
                GitHub Crawler
              </Typography>
            </motion.div>

            <motion.div
              animate={scrolled ? "glow" : "idle"}
              variants={neonVariants}
              style={{ marginLeft: 'auto' }}
            >
              <Typography
                variant="caption"
                sx={{
                  color: '#00D4FF',
                  fontFamily: '"Orbitron", sans-serif',
                  fontWeight: 600,
                }}
              >
                LIVE
              </Typography>
            </motion.div>
          </Toolbar>
        </Container>
      </AppBar>
    </motion.div>
  );
};

export default AnimatedHeader;